
















import { Component, Prop, Vue ,Watch } from 'vue-property-decorator';
import { GroupMessage } from '@/interfaces/websocketMessageInterfaces';
import { uploadFileSplice } from '@/apis/common';
import { UploadFileIF } from '@/interfaces/types';
import calcTextareaHeight from '@/components/inputHeight/calcTextareaHeight';
import {htmlEncode} from '@/utils/utils';

@Component({})
export default class ChatInput extends Vue {
  @Prop() groupId!: number | string;
  private message: string = '';
  private emitMessage: GroupMessage = {
    groupId: 0,
    fromUid: 0,
    msgType: 0,
    msgContent: this.message,
    createTime: 0,
    uniqueCode: 0,
    msgtatus: 0, //1表示发送中  2表示发送结束
  };
  private inputHeight: string = '32px';

  handleKeyPress(e: KeyboardEvent) {
    if (e.keyCode === 13) {
      this.submit();
    }
  }

  @Watch('message')
  getMessageVal(newVal: Array<any>, oldVal: Array<any>){
     this.getHeight();
  }

  getHeight() {
    let text = this.$refs.textarea as any
    this.inputHeight = calcTextareaHeight(this.$refs.textarea, 1, null).height;
  }

  //发送消息
  submit() {
    this.message = htmlEncode(this.message);
    if (!this.message){
      this.$toast.fail('发送的消息不能为空');
      return;
    }
    //进行xss攻击的移除
    let uniqueCode = this.wsMsgModule.pushMessage({
      groupId: typeof this.groupId === 'number' ? this.groupId : Number(this.groupId),
      msgType: 0,
      msgContent: this.message,
      notifyUserArray: [],
    });
    this.emitMessage = {
      groupId: Number(this.groupId),
      fromUid: Number(this.wsMsgModule.loginParam.uid),
      msgType: 0,
      msgContent: this.message,
      createTime: new Date().getTime(),
      uniqueCode: uniqueCode,
      msgtatus: 1,
    };
    this.$emit('onSendMessage', this.emitMessage);
    this.message = '';
    this.inputHeight = '32px'
  }

  handleInputFileChange(e: any) {
    const fileList = e.target.files as FileList;
    const currentFile = fileList[0];
    let type = '';
    let messageType = 0;
    if (currentFile.type !== '') {
      type = currentFile.type.split('/')[0]; // 0.普通文字消息 1.图片消息 2.文件消息 3.语音消息 4.视频消息
    }
    switch (type) {
      case 'text':
        messageType = 0;
        break;
      case 'image':
        messageType = 1;
        break;
      case 'audio':
        messageType = 3;
        break;
      case 'video':
        messageType = 4;
        break;
      case 'application':
        messageType = 2;
        break;
      default:
        messageType = 0;
        return;
    }
    const blobChunkList = this.makeBlobChunkList(currentFile);
    for (let i = 0; i < blobChunkList.length; i++) {
      this.uploadFileChunk(blobChunkList, i, currentFile, 'computedMd5')
        .then((res) => {
          const resData = res as UploadFileIF;
          let uniqueCode = this.wsMsgModule.pushMessage({
            groupId: typeof this.groupId === 'number' ? this.groupId : Number(this.groupId),
            msgType: messageType,
            msgContent: resData.fileid,
            fileUrl: resData.fileid,
            notifyUserArray: [],
          });
          this.emitMessage = {
            groupId: Number(this.groupId),
            fromUid: Number(this.wsMsgModule.loginParam.uid),
            msgType: messageType,
            msgContent: resData.fileid,
            createTime: new Date().getTime(),
            uniqueCode: uniqueCode,
            msgtatus: 0,
          };
          this.$emit('onSendMessage', this.emitMessage);
          this.message = '';
        })
        .catch((e) => {
          const processData = e as { isChunk: boolean; chunk: string };
        });
    }
  }

  uploadFileChunk(blobChunkList: Array<Blob>, index: number, originFile: File, fileMd5: string): Promise<UploadFileIF | { isChunk: boolean; chunk: string } | undefined> {
    return uploadFileSplice(this.makeFormData(blobChunkList, index, originFile, fileMd5)).then((res) => {
      if (res.status === 1) {
        return Promise.resolve(res.data as UploadFileIF);
      } else if (res.status === 2) {
        return Promise.reject(res.data as { isChunk: boolean; chunk: string });
      } else if (res.status === 0) {
        this.uploadFileChunk(blobChunkList, index, originFile, fileMd5);
      }
    });
  }

  // 构建上传参数
  makeFormData(blobChunkList: Array<Blob>, index: number, originFile: File, fileMd5: string): FormData {
    const currentBlob = blobChunkList[index];
    const formData = new FormData();
    formData.append('fileMd5', fileMd5);
    formData.append('chunks', blobChunkList.length.toString());
    formData.append('chunk', index.toString());
    formData.append('file', currentBlob);
    formData.append('id', index.toString());
    formData.append('lastModifiedDate', originFile.lastModified.toString());
    formData.append('filename', originFile.name);
    formData.append('size', originFile.size.toString());
    return formData;
  }

  // 文件分片
  makeBlobChunkList(file: File): Array<Blob> {
    const CHUNK_SIZE = 5120000;
    // @ts-ignore
    const blobSliceFunction = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
    const blobList = [];
    console.log(file.size);
    if (file.size < CHUNK_SIZE) {
      blobList.push(file);
    } else {
      //
      const chunkNumber = Math.ceil(file.size / CHUNK_SIZE);
      for (let i = 0; i < chunkNumber; i++) {
        blobList.push(blobSliceFunction.call(file, i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE));
      }
    }
    return blobList;
  }
}
